import { APP_BACKGROUND_COLOR, APP_COLOR, APP_HOVER_COLOR } from "../../theme";

export const styles = {
  selectedSubscriptionPlan: {
    fontWeight: "bold",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0px 0px 40px rgba(0, 0, 0, 1)",
  } as const,
  selectedPlanHeading: {
    fontWeight: "bold",
    paddingBottom: 0,
    marginBottom: 0,
    fontSize: "24px",
  } as const,
  planHeading: {
    paddingBottom: 0,
    marginBottom: 0,
    fontSize: "24px",
  } as const,
  accordion: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
    textAlign: "center",
  } as const,
  planDetailsRow: {
    marginBottom: "10px",
  } as const,
  checkCircleRoundedIcon: {
    padding: "3px 6px 5px 0px",
  } as const,
  button: {
    margin: "10px",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    width: "120px",
    color: "black",
    backgroundColor: APP_COLOR,
  } as const,
  downgradeButton: {
    margin: "10px",
    width: "100%",
    color: "white",
    textDecoration: "underline",
  } as const,
  accordionItems: {
    textAlign: "left",
    width: "120%",
  },
};
